import React, { useEffect, useState } from 'react';
import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber';
import { useNetwork } from '../../../../../utils/network';
import CountdownTimer from '../CountdownTimer/CountdownTimer';

// Rendered inside the dashboard's `.dash` scope, so it borrows the shared arena
// panel classes (Dashboard.css) to sit flush with the other cards.
export const GiveawayDashboard: React.FC = () => {
  const { get } = useNetwork();
  const [nextGiveaway, setNextGiveaway] = useState<Date>();

  useEffect(() => {
    const fetchGiveawayCountdown = async () => {
      try {
        const data = await get('/giveaway/countdown', true);
        setNextGiveaway(new Date(data.endDate));
      } catch (error) {
        console.error('There was a problem with the network operation:', error);
      }
    };

    fetchGiveawayCountdown();
    // get is stable for this screen's lifetime; fetch once on mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="dash-panel" id="giveaway">
      <div className="dash-phead gold">
        <ConfirmationNumberIcon className="ic" /> 10K Monthly Giveaway
      </div>
      <div className="dash-pbody dash-center">
        {nextGiveaway ? (
          <>
            <div
              className="dash-unit"
              style={{ marginTop: 0, marginBottom: 14 }}
            >
              Draw closes in
            </div>
            <CountdownTimer nextGiveaway={nextGiveaway} isTiny />
          </>
        ) : (
          <div className="dash-state">Loading…</div>
        )}
      </div>
    </div>
  );
};
